(() => {
  const CONFIG = {
    giftVariantId: 58352522494287, // Sustituir por el ID real
    thresholdCents: 4500,          // 45,00 €
    giftProperty: '_automatic_gift',

     // Promoción:
  // Desde el 4 de agosto de 2026 a las 00:00
  // Hasta el 6 de agosto de 2026 a las 23:59
  startDate: '2026-08-03T22:00:00Z',
  endDate: '2026-08-06T21:59:59Z',
  };

  let isUpdating = false;
  let debounceTimer;

  const routesRoot = window.Shopify?.routes?.root || '/';

  function isGiftItem(item) {
    return (
      Number(item.variant_id) === Number(CONFIG.giftVariantId) &&
      item.properties?.[CONFIG.giftProperty] === 'true'
    );
  }
  
  function isPromotionActive() {
    const now = Date.now();
    const start = new Date(CONFIG.startDate).getTime();
    const end = new Date(CONFIG.endDate).getTime();

    return now >= start && now <= end;
  }

  function getQualifyingSubtotal(cart) {
    return cart.items.reduce((total, item) => {
      if (isGiftItem(item)) {
        return total;
      }

      return total + item.final_line_price;
    }, 0);
  }

  async function getCart() {
    const response = await fetch(`${routesRoot}cart.js`, {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`No se pudo consultar el carrito: ${response.status}`);
    }

    return response.json();
  }

  async function addGift() {
    const response = await fetch(`${routesRoot}cart/add.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        items: [
          {
            id: CONFIG.giftVariantId,
            quantity: 1,
            properties: {
              [CONFIG.giftProperty]: 'true',
            },
          },
        ],
      }),
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.description || 'No se pudo añadir el regalo');
    }
  }

  async function removeGift(giftItem) {
    const response = await fetch(`${routesRoot}cart/change.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        id: giftItem.key,
        quantity: 0,
      }),
    });

    if (!response.ok) {
      throw new Error('No se pudo eliminar el regalo');
    }
  }

  async function limitGiftToOne(giftItem) {
    if (giftItem.quantity === 1) {
      return;
    }

    const response = await fetch(`${routesRoot}cart/change.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        id: giftItem.key,
        quantity: 1,
      }),
    });

    if (!response.ok) {
      throw new Error('No se pudo ajustar la cantidad del regalo');
    }
  }

  async function refreshCartInterface() {
    /*
     * Horizon puede actualizar su carrito mediante componentes propios.
     * El evento ayuda a que otros scripts sepan que el carrito ha cambiado.
     */
    document.dispatchEvent(
      new CustomEvent('cart:refresh', {
        bubbles: true,
      })
    );

    window.dispatchEvent(
      new CustomEvent('cart:updated', {
        detail: {
          source: 'automatic-free-gift',
        },
      })
    );

    /*
     * En la página completa del carrito, recargamos para garantizar que
     * aparezca la nueva línea y el descuento nativo.
     */
    if (window.location.pathname.endsWith('/cart')) {
      window.location.reload();
    }
  }

  async function synchronizeGift() {
    if (isUpdating) {
      return;
    }

    isUpdating = true;

    try {
      const cart = await getCart();
      const giftItems = cart.items.filter(isGiftItem);
      const giftItem = giftItems[0];

      const promotionActive = isPromotionActive();
      const qualifyingSubtotal = getQualifyingSubtotal(cart);

      const qualifies =
        promotionActive &&
        qualifyingSubtotal >= CONFIG.thresholdCents;

      if (qualifies && !giftItem) {
        await addGift();
        await refreshCartInterface();
        return;
      }

      if (!qualifies && giftItem) {
        await removeGift(giftItem);
        await refreshCartInterface();
        return;
      }

      if (qualifies && giftItem && giftItem.quantity !== 1) {
        await limitGiftToOne(giftItem);
        await refreshCartInterface();
      }
    } catch (error) {
      console.error('[Regalo automático]', error);
    } finally {
      isUpdating = false;
    }
  }

  function scheduleSynchronization() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(synchronizeGift, 350);
  }

  /*
   * Primera comprobación al cargar la página.
   */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleSynchronization);
  } else {
    scheduleSynchronization();
  }

  /*
   * Captura adiciones y cambios del carrito realizados con fetch.
   */
  const originalFetch = window.fetch;

  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);

    const requestUrl =
      typeof args[0] === 'string'
        ? args[0]
        : args[0]?.url || '';

    if (
      requestUrl.includes('/cart/add') ||
      requestUrl.includes('/cart/change') ||
      requestUrl.includes('/cart/update') ||
      requestUrl.includes('/cart/clear')
    ) {
      scheduleSynchronization();
    }

    return response;
  };

  /*
   * Eventos habituales usados por temas y aplicaciones.
   */
  document.addEventListener('cart:change', scheduleSynchronization);
  document.addEventListener('cart:updated', event => {
    if (event.detail?.source !== 'automatic-free-gift') {
      scheduleSynchronization();
    }
  });
})();